import React from "react";
import { ReactComponent as BsInfoCircleFill } from "../../../assets/Icons/Universal/BsInfoCircleFill.svg";
import "../../../styles/ComponentsStyles/Universal/Tables/AcademicUniversalTable.style.css";

const AcademicUniversalTable = ({
  title,
  headers = [],
  data = [],
  showCheckbox = false,
  checkedItems = {},
  onSelectAll,
  onRowSelect,
  renderCell,
}) => {
  return (
    <div className="academic-universal-table-wrapper">
      {title && (
        <div className="table-header">
          <h3>
            {title}
            <BsInfoCircleFill />
          </h3>
          {showCheckbox && (
            <button onClick={onSelectAll}>
              {Object.keys(checkedItems).length === data.length
                ? "Deselect All"
                : "Select All"}
            </button>
          )}
        </div>
      )}

      <div className="table-container scroll-y">
        <table className="material-table">
          <thead>
            <tr>
              {headers.map((header) => (
                <th key={header.key}>
                  {header.label}
                </th>
              ))}
              {showCheckbox && <th>Select</th>}
            </tr>
          </thead>
          {/* <tbody>
            {data.map((mat) => (
              <tr key={mat?.itemCode}>
                <td>{mat?.vehicleNo}</td>
                <td>{mat?.routeNo}</td>
                <td>{mat?.dueAmount}</td>
                <td className="reporter">{mat?.reporter}</td>
                <td>
                  {showCheckbox && (
                    <td>
                      <input
                        type="checkbox"
                        checked={!!checkedItems[mat?.itemCode]}
                        onChange={() => onRowSelect(mat?.itemCode, mat)}
                      />
                    </td>
                  )}
                </td>
              </tr>
            ))}
          </tbody> */}
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={row?.itemCode || rowIndex}>
                {headers.map((header) => (
                  <td key={header.key}>
                    {renderCell ? renderCell(row, header.key) : row[header.key]}
                  </td>
                ))}
                {showCheckbox && (
                  <td>
                    <input
                      type="checkbox"
                      checked={!!checkedItems[row?.itemCode]}
                      onChange={() => onRowSelect(row?.itemCode, row)}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AcademicUniversalTable;
